// extracted by mini-css-extract-plugin
module.exports = {"csrToastMessage":"cat-toast-component_csrToastMessage__fAEVY"};